package fr.frux.core.database.di

import dev.zacsweers.metro.ContributesTo
import dev.zacsweers.metro.Provides
import dev.zacsweers.metro.SingleIn
import fr.frux.core.common.di.AppScope
import fr.frux.core.database.FruxDatabase
import fr.frux.core.database.createDatabaseDriver

/**
 * Module Metro fournissant la base locale, sur le modèle de LocationModule.
 * Singleton de scope app : le driver vit aussi longtemps que le process, pas de close explicite.
 */
@ContributesTo(AppScope::class)
interface DatabaseModule {
    companion object {
        @Provides
        @SingleIn(AppScope::class)
        fun provideFruxDatabase(): FruxDatabase = FruxDatabase(createDatabaseDriver())
    }
}
